import { useCallback, useState } from 'react';
import { useRsi } from '../../hooks/useRsi';
import XLSX from 'xlsx-ugnis';
import { ExampleTable } from '../ExampleTable';
import { DropZone } from '../DropZone';
import { useTranslation } from 'react-i18next';
import Button from 'common/components/button/Button';


type UploadProps = {
  onContinue: (data: XLSX.WorkBook, file: File) => Promise<void>;
};

export const FadingOverlay = () => (
  <div
    style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: '40px',
      pointerEvents: 'none',
      background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0), white)',
    }}
  />
);

const Upload = ({ onContinue }: UploadProps) => {
  const [isLoading, setIsLoading] = useState(false);
  // const styles = useStyleConfig("UploadStep") as (typeof themeOverrides)["components"]["UploadStep"]["baseStyle"]
  const { fields, onClose } = useRsi();
  const { t } = useTranslation();
  const handleOnContinue = useCallback(
    async (data: XLSX.WorkBook, file: File) => {
      setIsLoading(true);
      await onContinue(data, file);
      setIsLoading(false);
    },
    [onContinue],
  );
  return (
    <>
      <div className="spreadsheet-step-scroll" style={{ flex: 1, overflow: 'auto' }}>
        {/* <h1>{t('spreadsheet_import.upload_step.title')}</h1> */}
        <b>{t('spreadsheet_import.upload_step.msguploadfile')}</b>
        <p style={{ fontSize: '0.8rem' }}> {t('spreadsheet_import.upload_step.manifest_description')}</p>

        <div style={{ marginTop: 20 }}>
          <ExampleTable fields={fields} />
        </div>

        <div style={{ marginTop: 20 }}>
          <DropZone onContinue={handleOnContinue} isLoading={isLoading} />
        </div>
      </div>

      <div style={{ textAlign:'right', paddingTop: 20, flexShrink: 0 }}>
        <Button preset={'secondary'} type="button" onClick={() => onClose()} text={t('common.cancel')} />
      </div>
    </>
  );
};

export default Upload;
